/**
 * -----------------------------------------------------------------------------------------------------------
 * Account module
 * -----------------------------------------------------------------------------------------------------------
 */
export const SET_ACCOUNT_INFO = "SET_ACCOUNT_INFO";
export const REMOVE_ACCOUNT_INFO = "REMOVE_ACCOUNT_INFO";
export const SET_LANGUAGE = "SET_LANGUAGE";
